import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import GameTypesSection from './components/GameTypesSection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />

        <GameTypesSection />

        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                探索更多麻将内容
              </h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
                从规则入门到进阶技巧，从文化历史到实战心得，这里有你想要的一切麻将知识
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex items-start gap-4 p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300"
                >
                  <span className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-lg bg-accent-100 text-accent-700 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors duration-300">
                    <i className={`${cat.icon} text-lg`}></i>
                  </span>
                  <div className="min-w-0">
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors duration-200">
                      {cat.name}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                      {cat.description}
                    </p>
                    <span className="text-xs text-foreground-400">
                      {cat.articleCount} 篇文章
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <FeaturedArticles />

        <FAQSection />

        <CTASection />
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "麻将在线玩",
            "url": "https://majiangzaxianwan.com/",
            "description": "免费畅玩正宗麻将游戏，支持国标麻将、四川麻将、广东麻将等多种玩法",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://majiangzaxianwan.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "麻将在线玩需要下载安装吗？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "完全不需要！麻将在线玩是纯网页版麻将平台，打开浏览器即可开始游戏，无需下载任何软件或App。",
                },
              },
              {
                "@type": "Question",
                "name": "在线麻将支持哪些玩法？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "我们目前支持国标麻将、四川麻将（血战到底）、广东麻将（鸡平胡、推倒胡）等多种主流玩法。",
                },
              },
              {
                "@type": "Question",
                "name": "如何开始一局在线麻将？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "进入平台后，选择你喜欢的麻将玩法，系统会自动为你匹配水平相近的在线玩家。",
                },
              },
              {
                "@type": "Question",
                "name": "在线麻将如何保证公平性？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "我们的平台采用随机发牌算法，经过第三方机构认证，确保每一局游戏绝对公平。",
                },
              },
              {
                "@type": "Question",
                "name": "手机玩麻将会不会很卡？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "我们针对移动端做了深度优化，采用轻量级渲染引擎，即使在4G网络下也能流畅运行。",
                },
              },
              {
                "@type": "Question",
                "name": "可以邀请好友一起玩吗？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "当然可以！在平台创建私人房间后，将房间号分享给好友即可一起对战。",
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}